// extracted by mini-css-extract-plugin
export default {"new-time-dropdown":"NewTimeDropdown_new-time-dropdown__DM7IG"};